import React from 'react'

function RoadMap() {
    return (
        <div>
            <h1>Roadmap</h1>
        </div>
    )
}

export default RoadMap
